import { useQueryBuilder } from "../../useBuilders";
import { CATALOG, GATING, PUBLISHED } from "../../queryKeys";
import { gatingApi } from "src/services/experiences/storyboardSettings/gating";
import { GatingCatalogSearchRequest } from "src/types/experiences/storyboardSettings";

// Mirrors legacy: dispatch(fetchPublishedGatings({ storyboard, published:true }, 0, 50))
// fired on mount inside ContentGating and AutoGating. The query is keyed on
// storyboard + published + progressive so per-storyboard catalogs don't
// collide. We only enable it once we have a storyboard id (matches the
// legacy useEffect dependency on storyboard.id).
export const useGatingCatalogQuery = (
  request: GatingCatalogSearchRequest = {},
) => {
  const page = request.page ?? 0;
  const limit = request.limit ?? 50;
  const storyboard = request.storyboard ?? "";
  const published = request.published ? "1" : "0";
  const progressive = request.progressive ? "1" : "0";

  return useQueryBuilder(
    [
      GATING,
      CATALOG,
      PUBLISHED,
      storyboard,
      published,
      progressive,
      String(page),
      String(limit),
    ],
    () =>
      gatingApi.searchGatingCatalog({
        page,
        limit,
        storyboard: request.storyboard,
        published: request.published,
        progressive: request.progressive,
      }),
    false,
    5 * 60 * 1000,
    false,
    undefined,
    Boolean(storyboard),
  );
};
